import React from 'react';
import { css } from 'aphrodite';
import FolderOutlinedIcon from '@mui/icons-material/FolderOutlined';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import styles from './styles';
import { FolderData, ColumnConfig } from './types';

export const useFolderPickerColumns = (
  onExpandToggle?: (folderId: number) => void,
): ColumnConfig<FolderData>[] => {
  return [
    {
      label: '',
      dataKey: 'expandIcon',
      style: { width: '40px', textAlign: 'center' as const },
      render: (value: unknown, { rowData }: { rowData: FolderData }) => (
        <div className={css(styles.expandColumn)}>
          <button
            onClick={(e) => {
              e.stopPropagation();
              onExpandToggle?.(rowData.id);
            }}
            className={css(styles.expandButton)}
            aria-label={`${rowData.expanded ? 'Collapse' : 'Expand'} ${
              rowData.name
            } folder`}
          >
            <ChevronRightIcon
              style={{
                fontSize: 16,
                color: '#666',
                transform: rowData.expanded ? 'rotate(90deg)' : 'rotate(0deg)',
                transition: 'transform 0.2s ease-in-out',
              }}
            />
          </button>
        </div>
      ),
    },
    {
      label: '',
      dataKey: 'folderIcon',
      style: { width: '40px', textAlign: 'center' as const },
      render: () => (
        <div className={css(styles.iconColumn)}>
          <FolderOutlinedIcon className={css(styles.folderIcon)} />
        </div>
      ),
    },
    {
      label: 'Name',
      dataKey: 'name',
      style: { flex: 1, textAlign: 'left' as const },
      render: (value: unknown, { rowData }: { rowData: FolderData }) => (
        <div className={css(styles.nameColumn)}>
          <span className={css(styles.folderName)}>{rowData.name}</span>
          {rowData.isSelected && (
            <span className={css(styles.currentFolderChip)}>
              Current folder
            </span>
          )}
        </div>
      ),
    },
  ];
};

export default useFolderPickerColumns;
